const { normalizeSmsPreference, isSmsEnabled } = require('utils/smsPreference');

const PreferencesProgressHelpers = module.exports = {};

PreferencesProgressHelpers.buildProfilePreferenceProgressAction = ({
    field,
    value
}) => ({
    type: 'profile',
    field,
    payload: {
        [field]: value
    },
    shouldBlockPage: false
});

PreferencesProgressHelpers.buildPhonePreferenceProgressAction = ({
    field,
    value,
    preferenceProfileFields = []
}) => {

    if (!Array.isArray(field) || !field.some((_field) => preferenceProfileFields.includes(_field))) {
        return null;
    }

    if (!Array.isArray(value) || field === null || value === null) {
        return {
            type: 'none'
        };
    }

    return {
        type: 'profile',
        field: 'phone',
        payload: {
            phone: value[0],
            phoneCountry: value[1],
            sms: normalizeSmsPreference(value[2])
        },
        shouldBlockPage: true
    };
};

PreferencesProgressHelpers.buildSmsPreferenceProgressAction = (value) => ({
    type: 'profile',
    field: 'sms',
    payload: {
        sms: isSmsEnabled(value) ? 'on' : 'off'
    },
    shouldBlockPage: true
});

PreferencesProgressHelpers.buildPreferencesProgressAction = ({
    field,
    value,
    preferenceProfileFields = []
}) => {

    if (preferenceProfileFields.includes(field)) {
        return PreferencesProgressHelpers.buildProfilePreferenceProgressAction({
            field,
            value
        });
    }

    const phoneAction = PreferencesProgressHelpers.buildPhonePreferenceProgressAction({
        field,
        value,
        preferenceProfileFields
    });

    if (phoneAction) {
        return phoneAction;
    }

    if (field === 'sms') {
        return PreferencesProgressHelpers.buildSmsPreferenceProgressAction(value);
    }

    return {
        type: 'preferences',
        field,
        payload: {
            [field]: value
        },
        shouldBlockPage: false
    };
};
